import {FC, useCallback} from 'react';
import {Assignee} from '../../../constants/types';
import {Button} from '../../common/Button';
import {ProcessActions} from '../../../constants/constants';
import {getProcessClaimingButtonOptions} from '../helpers';
import ListOptions from '../../common/ListOptions';
import {MAX_USERS_TO_CLAIM_PROCESS} from '../constants';

type ProcessClaimingButtonProps = {
  id: number,
  assignees: Assignee[],
  onButtonClick: (
    id: number, processActionsType: ProcessActions,
    confirmBtnLabel: string, assigneeId: number) => void,
  currentUserId: Nullable<number>,
}

const ProcessClaimingButton: FC<ProcessClaimingButtonProps> = (
    {id, assignees, onButtonClick, currentUserId}
) => {
  const {
    mainOption: {
      name: mainOptionName,
      onClick: mainOptionOnClick,
      optionElementOnClick
    },
    otherOptions} =
    getProcessClaimingButtonOptions(assignees, currentUserId);

  const handleMainOptionClick = useCallback(() => {
    mainOptionOnClick(onButtonClick, id);
  }, [onButtonClick, id, mainOptionOnClick]);

  if (!otherOptions.length) {
    return (
      <div className="claim-cell">
        <Button
          label={mainOptionName}
          variant="text"
          size="small"
          onClick={handleMainOptionClick}
        />
      </div>
    );
  }

  const addInitialOption = otherOptions.length < MAX_USERS_TO_CLAIM_PROCESS ?
  {
    [mainOptionName]: {
      name: mainOptionName,
      onClick: handleMainOptionClick,
      disabled: false
    }
  } : {};


  const options = otherOptions.reduce((acc, {name, disabled, assigneeId}) => {
    acc[name] = {
      name,
      disabled,
      onClick: () => optionElementOnClick(onButtonClick, id, assigneeId)
    };

    return acc;
  }, addInitialOption);

  return (
    <div className="claim-cell">
      <ListOptions options={options} />
    </div>
  );
};

export default ProcessClaimingButton;
